import {formatPrice, formatPriceNumber} from '../common';

(function ($) {
  "use strict";
  $(function () {
    if ($(document).find('.x-delivery-page').length) {
      let myMap, polygonList, polygonPrice, placemarkList = [];

      try {
        ymaps.ready(init);
      } catch (e) {
        console.log('error ymaps', e);
      }

      let previous = false;
      let colors = {
        "2000": "#ba6161",
        "1800": "#9791bf",
        "1500": "#dc9a20",
        "1200": "#739ec1",
        "1000": "#c820dc",
        "900": "#7d797d",
        "800": "#f3d27f",
        "700": "#070584",
        "600": "#61ba97",
        "3500": "#00FF00",
        "3550": "#32CD32",
        "5500": "#FFA500",
        "5000": "#FFD700",
        "6000": "#FFA500",
        "5550": "#FFA500",
        "6100": "#FF0000",
        "6050": "#FF4500",
        "8500": "#FF6347",
        "8000": "#87CEEB",
        "8050": "#1E90FF",
        "8100": "#87CEEB",
        "12000": "#0000FF",
        "14999": "#000080",
        "5": "#C0C0C0",
      };

      function init() {
        $(document).find('#map').empty();
        $(document).find('#map').append('<div class="loader" title="Пожалуйста, подождите ...">\n' +
          '                                <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>\n' +
          '                            </div>');
        if (myMap) {
          myMap.destroy();// Деструктор карты
          myMap = null;
        }
        // Изменения масштаба
        let zoomControl = new ymaps.control.ZoomControl({
          options: {
            size: "large"
          }
        });
        // Карта
        myMap = new ymaps.Map('map', {
          zoom: 10,
          center: [55.648334, 37.596055],
          controls: [zoomControl],
        });

        $.ajax({
          url: '/ajax/map-zones.php',
          dataType: "json",
          success: function (data) {
            polygonList = [];
            polygonPrice = [];

            for (let j in data) {
              let p = data[j].c;
              for (let i in p) {
                p[i] = [p[i][1], p[i][0]];
              }

              let polygon = new ymaps.Polygon([p, []], {}, {
                fillColor: colors[data[j].sum],
                interactivityModel: 'default#transparent',
                strokeWidth: 1,
                opacity: 0.7
              });

              polygonList.push(polygon);
              polygonPrice.push(data[j].sum);

              myMap.geoObjects.add(polygon);
              // myMap.setBounds(polygon.geometry.getBounds());
            }
          }
        });

        myMap.events.add("click", function (e, coords) {
          let properties = {},
            options = {
              preset: 'twirl#lightblueStretchyIcon',
              draggable: true,
              zIndex: 10000,
              zIndexActive: 10000,
              zIndexHover: 10000
            };

          if (typeof coords === 'undefined') {
            coords = e.get('coordPosition');
          }
          if (typeof coords === 'undefined') {
            coords = e.get('coords');
          }

          for (let p in placemarkList) {
            myMap.geoObjects.remove(placemarkList[p]);
          }

          addPlacemark(coords, properties, options);

          let index,
            todayPrice = '';

          for (index = 0; index < polygonList.length; ++index) {
            if (polygonList[index].geometry.contains(coords)) {
              todayPrice = polygonPrice[index];
            }
          }

          if (todayPrice >= 100000) {
            todayPrice = 1;
            $('.js-map-form').show();
          } else if (todayPrice == '') {
            $('.js-map-form').show();
          } else {
            $('.js-map-form').hide();
          }

          showDeliveryInfoByTodayPrice(todayPrice);
          showTablePriceDiscount(todayPrice);
        });

        $(document).find('.loader').hide();
      }

      function addPlacemark(coords, properties, options) {
        let placemark = {};
        placemark = new ymaps.Placemark(coords, properties, options);

        placemark.events.add('click', function () {
          myMap.geoObjects.remove(placemark);
        });
        myMap.geoObjects.add(placemark);
        placemarkList.push(placemark);
      }

      let selected = false;
      let housetime = false;

      function checkDeliveryPrice() {
        if (selected && (!housetime || (new Date()).getTime() - housetime.getTime() > 1500)) {
          let s = $(document).find("#address-delivery").val().trim();
          let h = $(document).find("#house").val().trim();
          if (s) {
            if (h) {
              $(document).find('.form-group-help').text('');
              let $obXMapAlert = $(document).find('.x-map-alert');
              let $obMapAlert = $(document).find('div.map-alert');
              if ($obXMapAlert.length) {
                $obXMapAlert.removeClass('map-alert-success');
                $obXMapAlert.removeClass('map-alert-error');
                $obXMapAlert.html(' <div class="loader" title="Пожалуйста, подождите ...">\n' +
                  '                <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>\n' +
                  '            </div>');
              } else {
                $obMapAlert.removeClass('map-alert-success');
                $obMapAlert.removeClass('map-alert-error');
                $obMapAlert.html(' <div class="loader" title="Пожалуйста, подождите ...">\n' +
                  '                <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>\n' +
                  '            </div>');
              }

              $.ajax({
                url: '/ajax/checkDelivery.php',
                data: {
                  url: 'http://hrm.hatimaki.ru/index.php',
                  r: "maps/google/check-address-json",
                  site_id: "2",
                  address: s + ", д" + h,
                },
                success: function (data) {
                  let res = JSON.parse(data);
                  if (res.min_price >= 100000) {
                    res.min_price = 1;
                    $('.js-map-form').show();
                  } else if (res.min_price == null) {
                    $('.js-map-form').show();
                  } else {
                    $('.js-map-form').hide();
                  }
                  showDeliveryInfoByTodayPrice(res ? res.min_price : 0);
                  showTablePriceDiscount(res ? res.min_price : 0);
                  if (res.min_price > 0) {
                    redrawMap(s + ", д" + h);
                  } else {
                    if (myMap) {
                      myMap.getObjects.remove(previous);
                      previous = false;
                    }
                  }
                }
              });
            } else {
              $(document).find('.form-group-help').text('Введите номер дома');
            }
          }
        }
      }

      function showDeliveryInfoByTodayPrice(price) {
        let $obXMapAlert = $(document).find('.x-map-alert');
        let $obMapAlert = $(document).find('div.map-alert');

        if (price > 0) {
          let todayMinPrice,
            tomorrowMinPriceFormat,
            tomorrowMinPrice;

          todayMinPrice = price > 1 ? formatPrice(price) : '<div class="text-gray">не возможна</div>';
          tomorrowMinPrice = parseInt(zoneList[price]);
          tomorrowMinPriceFormat = formatPrice(tomorrowMinPrice);
          if (!tomorrowMinPrice && price > 1) {
            tomorrowMinPrice = price;
          }

          if ($obXMapAlert.length) {
            let deliveryInfo = deliveryPriceList[price],
              arPrice = [],
              minPrice = 0,
              html = "";

            if (deliveryInfo.DELIVERY_TODAY_BEFORE_INTERVAL_1 > 1) {
              arPrice.push(deliveryInfo.DELIVERY_TODAY_BEFORE_INTERVAL_1);
            }
            if (deliveryInfo.DELIVERY_TODAY_FROM_INTERVAL_1 > 1) {
              arPrice.push(deliveryInfo.DELIVERY_TODAY_FROM_INTERVAL_1);
            }
            if (deliveryInfo.DELIVERY_TODAY_FROM_INTERVAL_2 > 1) {
              arPrice.push(deliveryInfo.DELIVERY_TODAY_FROM_INTERVAL_2);
            }

            if (deliveryInfo.DELIVERY_TOMORROW_BEFORE_INTERVAL_1 > 1) {
              arPrice.push(deliveryInfo.DELIVERY_TOMORROW_BEFORE_INTERVAL_1);
            }
            if (deliveryInfo.DELIVERY_TOMORROW_FROM_INTERVAL_1 > 1) {
              arPrice.push(deliveryInfo.DELIVERY_TOMORROW_FROM_INTERVAL_1);
            }
            if (deliveryInfo.DELIVERY_TOMORROW_FROM_INTERVAL_2 > 1) {
              arPrice.push(deliveryInfo.DELIVERY_TOMORROW_FROM_INTERVAL_2);
            }

            minPrice = Math.min.apply(null, arPrice);

            $obXMapAlert.addClass('map-alert-success');

            if (tomorrowMinPrice === 899) {
              html = '<p>Минимальный заказ при доставке на <span class="text-important">сегодня</span>:</p>\n' +
                '<div class="min-sum">' + todayMinPrice + '</div>' +
                '<p>Минимальный заказ на <span class="text-important">завтра и следующие дни</span>:</p>\n' +
                '<div class="min-sum"><span class="old-price">' + formatPrice(1200) + '</span> ' + tomorrowMinPriceFormat + '<sup>*</sup></div>' +
                '<div class="notion">* до 10.06.2020</div>';

              if (parseInt(minPrice) > 0) {
                html = html +
                  '<p>Стоимость <span class="text-important">платной доставки</span>:</p>\n' +
                  '<div class="min-sum">от ' + formatPrice(minPrice) + '</div>';
              }

              $obXMapAlert.html(html);
            } else {
              html = '<p>Минимальный заказ при доставке на <span class="text-important">сегодня</span>:</p>\n' +
                '<div class="min-sum">' + todayMinPrice + '</div>' +
                '<p>Минимальный заказ на <span class="text-important">завтра и следующие дни</span>:</p>\n' +
                '<div class="min-sum">' + tomorrowMinPriceFormat + '</div>';

              if (parseInt(minPrice) > 0) {
                html = html +
                  '<p>Стоимость <span class="text-important">платной доставки</span>:</p>\n' +
                  '<div class="min-sum">от ' + formatPrice(minPrice) + '</div>';
              }

              $obXMapAlert.html(html);
            }
          } else {
            $obMapAlert.addClass('map-alert-success');

            if (tomorrowMinPrice === 899) {
              $obMapAlert.html(
                '<p>Минимальный заказ при доставке на <span class="text-important">сегодня</span>:</p>\n' +
                '<div class="min-sum">' + todayMinPrice + '</div>' +
                '<p>Минимальный заказ на <span class="text-important">завтра и следующие дни</span>:</p>\n' +
                '<div class="min-sum"><span class="old-price">' + formatPrice(1200) + '</span> ' + tomorrowMinPriceFormat + '<sup>*</sup></div>' +
                '<div class="notion">* до 10.06.2020</div>'
              );
            } else {
              $obMapAlert.html(
                '<p>Минимальный заказ при доставке на <span class="text-important">сегодня</span>:</p>\n' +
                '<div class="min-sum">' + todayMinPrice + '</div>' +
                '<p>Минимальный заказ на <span class="text-important">завтра и следующие дни</span>:</p>\n' +
                '<div class="min-sum">' + tomorrowMinPriceFormat + '</div>'
              );
            }
          }
        } else {
          if ($obXMapAlert.length) {
            $obXMapAlert.addClass('map-alert-error');
            $obXMapAlert.html('<p>К сожалению, для указанного адреса мы не можем доставить заказ.</p>');
          } else {
            $obMapAlert.addClass('map-alert-error');
            $obMapAlert.html('<p>К сожалению, для указанного адреса мы не можем доставить заказ.</p>');
          }
        }
      }

      $(document).on('input', '#address-delivery', function () {
        selected = false;
      });

      $(document).find('#house').keypress(function (e) {
        if (e.keyCode === 13) {
          housetime = false;
          checkDeliveryPrice();
        }
      });

      $(document).on('input', '#house', function () {
        housetime = new Date();
        setTimeout(function () {
          checkDeliveryPrice();
        }, 1500)
      });

      $(document).find("#address-delivery").blur(function () {
        setTimeout(function () {
          if (!selected) {
            $(document).find("#address-delivery").val('');
          }
        }, 200)
      })

      $(document).find("#address-delivery").autocomplete({
        source: "/ajax/autocompleteAddress2.php",
        minLength: 1,
        appendTo: '#address-container',
        focus: function (event, ui) {
          selected = false;
        },
        select: function (event, ui) {
          selected = true;
          checkDeliveryPrice();
        }
      });

      function clear(cls) {
        let $obXMapAlert = $(document).find('.x-map-alert');
        let $obMapAlert = $(document).find('div.map-alert');

        $(document).find('.form-group-help').text('Введите улицу, номер дома и выберите предложенный вариант');
        if ($obXMapAlert.length) {
          $obXMapAlert.removeClass(cls);
          $obXMapAlert.html('<p>Здесь будет отображаться <span class="text-danger">сумма минимального заказа</span> для указанного адреса.</p>');
        } else {
          $obMapAlert.removeClass(cls);
          $obMapAlert.html('<p>Здесь будет отображаться <span class="text-danger">сумма минимального заказа</span> для указанного адреса.</p>');
        }

        init();
        $(document).find('#address-delivery').val('');
      }

      function redrawMap(address) {
        ymaps.geocode(address, {
          results: 1
        }).then(function (res) {
          // Выбираем первый результат геокодирования.
          let firstGeoObject = res.geoObjects.get(0),
            // Координаты геообъекта.
            coords = firstGeoObject.geometry.getCoordinates();
          // Область видимости геообъекта.
          // bounds = firstGeoObject.properties.get('boundedBy');
          $(document).find('.loader').hide();
          firstGeoObject.options.set('preset', 'islands#darkBlueDotIconWithCaption');
          // Получаем строку с адресом и выводим в иконке геообъекта.
          firstGeoObject.properties.set('iconCaption', firstGeoObject.getAddressLine());
          // Добавляем первый найденный геообъект на карту.
          // Масштабируем карту на область видимости геообъекта.
          myMap.setBounds(coords, {
            // Проверяем наличие тайлов на данном масштабе.
            duration: 300,
            checkZoomRange: true
          });

          if (previous) {
            myMap.geoObjects.remove(previous);
          }
          myMap.geoObjects.add(firstGeoObject);
          myMap.setCenter(coords, 14, {
            duration: 300,
          });
          previous = firstGeoObject;
        });
      }

      $(window).on("load resize", function () {
        let winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (winWidth >= 900) {
          $(document).find(".content-page-scroll .content").mCustomScrollbar({
            axis: "y",
            theme: "light-3"
          });
        } else {
          $(document).find('.content-page-scroll .content').mCustomScrollbar("destroy");
        }
      });

      $(function () {
        initNavbar();
        $(document).find("[data-form]").submit(function (e) {
          e.preventDefault();
          return false;
        })
      });

      function costCheck(price) {
        if (price > 1) {
          return formatPriceNumber(price);
        } else if (parseInt(price) === 0) {
          return 'бесплатно';
        } else {
          return 'нет';
        }
      }

      function showTablePriceDiscount(price) {
        let $deliveryPageTable = $(document).find('.x-delivery-table-box');
        if ($deliveryPageTable.length) {
          let deliveryInfo = deliveryPriceList[price];
          if (deliveryInfo) {
            $deliveryPageTable
              .find('.x-delivery-table-text-before-1')
              .html('до ' + formatPriceNumber(deliveryInfo.AMOUNT_INTERVAL_1));

            $deliveryPageTable
              .find('.x-delivery-table-text-from-1')
              .html('от ' + formatPriceNumber(deliveryInfo.AMOUNT_INTERVAL_1));

            $deliveryPageTable
              .find('.x-delivery-table-text-from-2')
              .html('от ' + formatPriceNumber(deliveryInfo.AMOUNT_INTERVAL_2));

            $deliveryPageTable
              .find('.x-delivery-table-price-today-before-1')
              .html(costCheck(deliveryInfo.DELIVERY_TODAY_BEFORE_INTERVAL_1));

            $deliveryPageTable
              .find('.x-delivery-table-price-today-from-1')
              .html(costCheck(deliveryInfo.DELIVERY_TODAY_FROM_INTERVAL_1));

            $deliveryPageTable
              .find('.x-delivery-table-price-today-from-2')
              .html(costCheck(deliveryInfo.DELIVERY_TODAY_FROM_INTERVAL_2));

            $deliveryPageTable
              .find('.x-delivery-table-price-tomorrow-before-1')
              .html(costCheck(deliveryInfo.DELIVERY_TOMORROW_BEFORE_INTERVAL_1));

            $deliveryPageTable
              .find('.x-delivery-table-price-tomorrow-from-1')
              .html(costCheck(deliveryInfo.DELIVERY_TOMORROW_FROM_INTERVAL_1));

            $deliveryPageTable
              .find('.x-delivery-table-price-tomorrow-from-2')
              .html(costCheck(deliveryInfo.DELIVERY_TOMORROW_FROM_INTERVAL_2));

            $deliveryPageTable.removeClass('hide');
          } else {
            $deliveryPageTable.addClass('hide');
          }
        }
      }
    }
  });
})(jQuery);
